// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cd15cd0e","363":"087ed17e","616":"7ce7cfac","860":"aea7f453"}[chunkId] + ".chunk.js";
};